var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.255859,
    y: 0.242188,
    width: 26.5596,
    height: 24.8276,
    rx: 3,
    fill: "white",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1071 9.98958H17.3452V8.46577C17.3452 6.36292 15.6385 4.65625 13.5357 4.65625C11.4328 4.65625 9.72614 6.36292 9.72614 8.46577V9.98958H8.96424C8.12614 9.98958 7.44043 10.6753 7.44043 11.5134V19.1324C7.44043 19.9705 8.12614 20.6562 8.96424 20.6562H18.1071C18.9452 20.6562 19.6309 19.9705 19.6309 19.1324V11.5134C19.6309 10.6753 18.9452 9.98958 18.1071 9.98958ZM11.25 8.46577C11.25 7.20101 12.2709 6.18006 13.5357 6.18006C14.8004 6.18006 15.8214 7.20101 15.8214 8.46577V9.98958H11.25V8.46577ZM18.1071 19.1324H8.96424V11.5134H18.1071V19.1324ZM13.5357 16.8467C14.3738 16.8467 15.0595 16.161 15.0595 15.3229C15.0595 14.4848 14.3738 13.7991 13.5357 13.7991C12.6976 13.7991 12.0119 14.4848 12.0119 15.3229C12.0119 16.161 12.6976 16.8467 13.5357 16.8467Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLock);
export default __webpack_public_path__ + "static/media/plus_lock.035bd596a7fcfae17aeafbbcdc6c42a8.svg";
export { ForwardRef as ReactComponent };